import { MdErrorOutline, MdCheckCircleOutline } from "react-icons/md";
import { FiAlertTriangle } from "react-icons/fi";
import { useAppState } from "../../hooks"
import { useEffect, useRef, useState } from "react";
import { TInfoMessage } from "../../types";

export const InfoMessage: React.FC = () => {
    const { state } = useAppState()

    const [message, setMessage] = useState<TInfoMessage | undefined>(undefined)
    const timeoutRef = useRef<number | undefined>();

    useEffect(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        if (state?.message) {
            setMessage(state?.message)
        } else {
            setMessage(undefined)
        }
    }, [state?.message])

    useEffect(() => {
        if (message?.timeout) {
            timeoutRef.current = window.setTimeout(() => {
                setMessage(undefined);
            }, message.timeout * 1000);
        }
    }, [message])

    if (!message) {
        return <></>
    }

    return (
        <div className='infoMessage'>
            <div className={message.type}>
                <div className='infoMessage__icon'>
                {{
                    'error': <MdErrorOutline color='red' size='20'/>,
                    'alert': <FiAlertTriangle color='orange' size='20' />,
                    'success': <MdCheckCircleOutline color='green' size='20' />
                    }[message.type]}
                </div>
                <div className='infoMessage__icon' dangerouslySetInnerHTML={{ __html: message.message }}/>
            </div>
        </div>
    )
}